<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="userGroups"
      :items="userGroups"
      :fields="userGroupsFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedUserGroups" :isEdit="isEdit"/>
  </div>
</template>

<script>
import editModal from './editModal'
export default {
  components: {
    editModal
  },
  data () {
    return {
      isEdit: null,
      userGroupsFields: [
        { key: 'group_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'group_name', label: this.$i18n.t('Name'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      selectedUserGroups: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.isEdit = false
      this.selectedUserGroups = {
        group_id: '',
        group_name: ''
      }
      this.$root.$emit('bv::show::modal', 'modalEditUsersGroups', '#btnShow')
    },
    editItem (item) {
      this.isEdit = true
      this.selectedUserGroups = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditUsersGroups', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure want to delete one of "Groups"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Users/DELETE_GROUPS', item.group_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Users/GET_GROUPS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    userGroups () {
      return this.$store.getters['Users/GROUPS']
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_GROUPS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/groups/main.vue